import { ChangeDetectionStrategy,Component  } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { ITextareaInput } from '../../interface';
import { InputsModule } from '../../inputs.module';

@Component({
    selector: 'input-textarea',
    templateUrl: './textarea.component.html',
    styleUrl: './textarea.component.scss',
    imports: [InputsModule]
})
export class InputTextareaComponent extends BaseInputComponent<any> {



  constructor() {
    super();

  }
}
